export default __webpack_public_path__ + "static/media/img_shop-product02.ec89e4c6.png";